import { connect } from 'react-redux';
import NotFoundError from './NotFoundError';

const mapStateToProps = ({ siteInfo }) => ({
    siteInfo,
});

export default connect(mapStateToProps)(NotFoundError);
